<template>
    <b-card no-body>
        <b-nav class="annc-tabs" tabs fill>
            <b-nav-item v-for="(tab, key) in tabs"
                        :key="key"
                        class="annc-tabs"
                        :active-class="'active annc-tabs'"
                        :exact-active-class="'active annc-tabs'"
                        :exact="tab.exact"
                        :to="tab.route"
            >
                <fa-icon :icon="tab.icon" />
                {{ tab.name }}
            </b-nav-item>
        </b-nav>
        <b-form-row>
            <router-view :key="$route.fullPath" />
        </b-form-row>
    </b-card>
</template>


<script>

export default {
    name: 'Announcements',

    data() {
        return {
        };
    },

    computed: {
        tabs() {
            return [
                {
                    icon: 'list-ol',
                    name: 'Announcement List',
                    exact: false,
                    route: {
                        name: 'admin.announcements.AnnouncementList',
                    },
                },
                {
                    icon: 'satellite-dish',
                    name: 'Create Announcement',
                    exact: false,
                    route: {
                        name: 'admin.announcements.AnnouncementCreate',

                    },
                },
                // {
                //     icon: 'file-alt',
                //     name: 'Update Announcement',
                //     exact: true,
                //     route: {
                //         name: 'admin.announcements.AnnouncementUpdate',
                //     },
                // },
            ];
        },
    },

    async created() {
    },

    // methods: {
    //     isEditing() {
    //     :disabled="isEditing()"
    //             }
    // },
};
</script>
<style lang="scss">
@import '$StyleVars';

.annc-tabs {
    font-size: 14px;
    background-color: hsla(201, 65%, 30%, .15);

    & .nav-link {
        padding: 0.5rem 0.25rem 0.5rem 0.75rem;
        color: $ace-blue;
        &:hover,
        &:focus {
            color: $gray-100;
            background-color: hsla(201, 65%, 30%, .75);
        }
        &.active {
                color: $gray-100;
                font-weight: bold;
                background: linear-gradient(
                -90deg,
                hsla(201, 65%, 30%, 1) 0%,
                hsla(201, 65%, 30%, .5) 100%
            );
        }
    }
 .card-body {
        padding: 0;
    }
}
</style>
